/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';
import { AllManufacturer } from './TableHead';
import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';
import { radioGroupLabelNamePlan } from '../../../../SharedModules/CommonConstants/commonConstants';
import _ from 'lodash';
import {
  Checkbox,
  FormControlLabel,
  MenuItem,
  Radio,
  TextField,
} from '@material-ui/core';
import {
  REBATE_PROGRAM_REQUIRED,
  STATUS_MSG,
  SUCCESS_MSG,
  ERRORMESSAGE_MFR_NOT_EMPTY_FOR_UNIT_CONVERSION,
} from '../../../../SharedModules/Errors/constantMessageData';
import {
  dispatchErrorMsgOutStandingBalByLabererAndQtr,
  getRebateProgrameList,
  getPlanTypeValues,
  getManufacturerList,
  setSearchResult,
  getOutstandingByLabererAndQtr,
  dispatchOutstandingByLabererAndQtr,
} from '../Store/Action';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import Spinner from '../../../../SharedModules/Spinner/Spinner';
import { tabHighLigther } from '../../../../SharedModules/utilities/utilities';
import { navigateToRequest } from './ConstantData';
import { clearReduxForFilterAndSort } from '../../../../SharedModules/Table/store/Actions';
import { handleScrollToEvent } from '../../../../SharedModules/CommonUtilities/commonUtilities';

const ReqOutstandingByLabererAndQuarter = (props) => {
  const dispatch = useDispatch();

  const {
    planType: planTypeList,
    rebateProgram: getRebateProgramList,
    rebateProgrameName: getRebateProgramName,
    selectedPlanType,
    performDisputeResolutionObj: requestCurrentDisData,
    manufacturerList: resultanufacturerList,
    generateInvoiceTabObj: searchScreenTabData,
    searchResult: getSearchResult,
    isLoading,
    errorMessages: getErrorMsg,
    allRebateProgram: allRebateProgramValue,
    isAllManufacturersSelected: isAllManufacturersSelectedValue,
    selectRowIndex: selectRowIndexValue,
  } = useSelector(
    (state) => state?.sharedState?.OutstandingBalanceByLabererAndQuarterReducer
  );

  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );

  const [rebateProgramList, setRebateProgramList] = React.useState([]);
  const [radioList, setRadioList] = React.useState([]);
  const [fullScreenView, setFullScreenView] = React.useState(false);
  const [allRebateProgram, setAllRebateProgram] = React.useState(
    allRebateProgramValue
  );
  const [manufacturerList, setManufacturerList] = React.useState([]);
  const [isAllManufacturersSelected, setIsAllManufacturersSelected] =
    React.useState(isAllManufacturersSelectedValue);
  // const [scrollDownManufacturers, setScrollDownManufacturers] =
  // React.useState(true);
  const [selectedRows, setSelectedRows] = React.useState([]);
  const [manufacturerSelected, setManufacturerSelected] = React.useState('ALL');
  const [isSearchClicked, setSearchClicked] = React.useState(false);

  // states with initial values
  const [state, setState] = React.useState(
    requestCurrentDisData?.state
      ? requestCurrentDisData?.state
      : {
          planTypeCd: userDefaults?.planTypeCd
            ? selectedPlanType || userDefaults?.planTypeCd
            : 'FD',
          rebateProgramCd: userDefaults?.rebateProgramCd
            ? getRebateProgramName?.rebateProgramCd ||
              userDefaults?.rebateProgramCd
            : '-1',
          manufacturers: false,
        }
  );

  //  tab highliter Functionality
  React.useEffect(() => {
    if (getErrorMsg && getErrorMsg.length > 0) {
      tabHighLigther(navigateToRequest, true);
    } else {
      tabHighLigther(navigateToRequest, false);
    }
  }, [JSON.stringify(getErrorMsg)]);

  // Plan type useEffect
  React.useEffect(() => {
    handleScrollToEvent();
    if (!planTypeList?.PLAN_TYPE_CD) {
      dispatch(getPlanTypeValues({}));
    }
  }, []);

  //Resetting Error message on selection change
  React.useEffect(() => {
    dispatch(dispatchErrorMsgOutStandingBalByLabererAndQtr([]));
  },[allRebateProgram, isAllManufacturersSelected])

  //setting radioList from planList Api
  React.useEffect(() => {
    if (
      planTypeList &&
      planTypeList.PLAN_TYPE_CD &&
      planTypeList.PLAN_TYPE_CD.length > 0
    ) {
      const planList = planTypeList.PLAN_TYPE_CD.map((obj) => {
        return {
          disabled: allRebateProgram,
          name:
            obj.codeValueID.codeValue === 'FD'
              ? 'Medicaid'
              : obj.shortDescription,
          value: obj.codeValueID.codeValue,
        };
      });
      setRadioList([
        ...planList.filter((obj) => obj.name === 'Medicaid'),
        ...planList.filter((obj) => obj.name !== 'Medicaid'),
      ]);
    }
  }, [planTypeList]);

  // get rebate program
  React.useEffect(() => {
    rebatepgmDropdown(state.planTypeCd);
  }, [state.planTypeCd]);

  // set Rebate Program List
  const rebatepgmDropdown = async (planType) => {
    let getRebateProgramList = await dispatch(
      getRebateProgrameList(state.planTypeCd)
    );
    let list = [];
    if (
      getRebateProgramList?.status === STATUS_MSG &&
      getRebateProgramList?.message === SUCCESS_MSG
    ) {
      if (!_.isEmpty(getRebateProgramList.data)) {
        list = _.map(getRebateProgramList.data, (val) => ({
          ...val,
          id: val.rebateProgramCd,
          name: `${val.rebateProgramCd} | ${val.shortDescr}`,
        }));
      }
    }
    setRebateProgramList(
      list.sort((key, val) =>
        key.name.toLowerCase().localeCompare(val.name.toLowerCase())
      )
    );
  };

  // on change event on filed
  const handleOnChangeEvent = (value, name) => {
    let localErr = getErrorMsg || [];
    dispatch(dispatchErrorMsgOutStandingBalByLabererAndQtr([]));
    if (name === 'planTypeCd') {
      setState({ ...state, [name]: value, rebateProgramCd: '-1' });
      if (value === 'ST' || value === 'FD') {
        dispatch(
          getManufacturerList({
            planType: 'st',
            asMode: 1,
          })
        );
      }
      if (value === 'SUPP' || value === 'COMM') {
        dispatch(
          getManufacturerList({
            planType: 'supp',
            asMode: 1,
          })
        );
      }
    }
    if (name === 'rebateProgramCd') {
      setState({ ...state, [name]: value });
    }
  };

  // on blur functionality on field level
  const handleOnblurEvent = (type, value) => {
    let localErr = getErrorMsg || [];
    const data = value;
    if (type === 'rebateProgramCd') {
      localErr = localErr.filter((item) => item.field !== 'rebateProgramCd');
    }

    if (type === 'manufacturer') {
         if (manufacturerSelected?.length === 0) {
           localErr = localErr.filter(
             (item) => item.field !== 'manufacturerSelect'
           );
           localErr.push({
             field: 'manufacturerSelect',
             errorType: 'manuRequired',
             message: ERRORMESSAGE_MFR_NOT_EMPTY_FOR_UNIT_CONVERSION,
           });
         } else {
           localErr = localErr.filter(
             (item) => item.field !== 'manufacturerSelect'
           );
         }
       }
    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgOutStandingBalByLabererAndQtr(unique));
  };

  //To get manufacturer List
  React.useEffect(() => {
    dispatch(
      getManufacturerList({
        planType: 'fd',
        asMode: 1,
      })
    );
  }, []);

  //Manufacturer Grid From API
  React.useEffect(() => {
    setManufacturerList(resultanufacturerList?.rebatePercentOfSpendMfgGridVO);
  }, [resultanufacturerList]);

  // fullscreen functionality
  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
  };

  //On selection of the row data
  const onSelectionChanged = (e) => {
    const selectedRows = e.api?.getSelectedRows();
    setSelectedRows(selectedRows);

    if (
      selectedRows?.length === manufacturerList?.length
      // || selectedRows.length === 0
    ) {
      setManufacturerSelected('ALL');
    } else {
      const selectedManuId = [];
      for (let i = 0; i < selectedRows.length; i++) {
        selectedManuId.push(selectedRows[i].mfgId);
      }
      selectedManuId.sort();
      setManufacturerSelected(selectedManuId);
      let localErr = getErrorMsg || [];
      localErr = localErr.filter((item) => item.field !== 'manufacturerSelect');
      const unique = [...new Set(localErr)];
      dispatch(dispatchErrorMsgOutStandingBalByLabererAndQtr(unique));
    }
  };

  //On search button functionality
const onClickSearch = async () => {
    let localErr = getErrorMsg || [];
    if (localErr.length > 0) {
      localErr = [];
    }
    if (state.rebateProgramCd === '-1' && allRebateProgram === false) {
      localErr.push({
        field: 'rebateProgramCd',
        errorType: 'rebateRequired',
        message: REBATE_PROGRAM_REQUIRED,
      });
    }
     if (!isAllManufacturersSelected && 
      (manufacturerSelected === '' || manufacturerSelected?.length === 0)
  ) {
    localErr.push({
      field: 'manufacturerSelect',
      errorType: 'manuRequired',
      message: ERRORMESSAGE_MFR_NOT_EMPTY_FOR_UNIT_CONVERSION,
    });
  }
    
    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgOutStandingBalByLabererAndQtr(unique));
    if (localErr.length > 0) {
      window.scrollTo({
         top: 0,
         behavior: 'smooth'
      });

      return;
    }

    setSearchClicked(true);  
    const rebateProgramName = rebateProgramList.find(
      (item) => item.id == state.rebateProgramCd
    )?.rebateProgramCd;
    const rebateProgrameName = rebateProgramList.find(
      (item) => item.id == state.rebateProgramCd
    );
    let index = manufacturerList.findIndex(
      (obj) => obj.mfgId === selectedRows[0]?.mfgId
    );
    index = index === -1 ? 0 : index;
    setSearchClicked(true);
    dispatch(
      setSearchResult({
        rebateProgramName,
        rebateProgrameName,
        selectedPlanType: state.planTypeCd,
        allRebateProgram,
        manufacturerSelected,
        isAllManufacturersSelected,
        selectRowIndex: index,
        displayObj: {
          rebateProgramName,
          rebateProgrameName,
          selectedPlanType: state.planTypeCd,
          allRebateProgram,
          manufacturerSelected,
          isAllManufacturersSelected,
          selectRowIndex: index,
        },
      })
    );

    const response = await dispatch(
      getOutstandingByLabererAndQtr({
        mfgId: manufacturerSelected === 'ALL' ? manufacturerSelected : manufacturerSelected[0],
        rebateProgram: allRebateProgram ? 'ALL' : rebateProgramName,
      })
    );

    if (!response || response?.length === 0) {
      return; 
    }

      props.history.push({
        pathname: '/disOutstandingBalanaceByLabererAndQuarter',
      });
      dispatch(
        clearReduxForFilterAndSort('/disOutstandingBalanaceByLabererAndQuarter')
      );
      const updateTabs =
        JSON.parse(localStorage.getItem('tabItemsData')) === null
          ? []
          : JSON.parse(localStorage.getItem('tabItemsData'));
      updateTabs.push({
        navTo: '/disOutstandingBalanaceByLabererAndQuarter',
        value: 'Display Outstanding Balance by Labeler and Quarter',
      });
      localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
      
  };
  // if (isSearchClicked && getSearchResult?.length > 0) {
  //   setSearchClicked(false);
  // dispatch(dispatchOutstandingByLabererAndQtr([]));
  // props.history.push({
  //   pathname: '/disOutstandingBalanaceByLabererAndQuarter',
  // });
  // dispatch(
  //   clearReduxForFilterAndSort('/disOutstandingBalanaceByLabererAndQuarter')
  // );
  // const updateTabs =
  //   JSON.parse(localStorage.getItem('tabItemsData')) === null
  //     ? []
  //     : JSON.parse(localStorage.getItem('tabItemsData'));
  // updateTabs.push({
  //   navTo: '/disOutstandingBalanaceByLabererAndQuarter',
  //   value: 'Display Outstanding Balance by Labeler and Quarter',
  // });
  // localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
  // }

  //For No Data validation for auto Scroll
  React.useEffect(() => {
    // setErrorList(errors);
    if (isSearchClicked && getErrorMsg?.length > 0) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  }, [getErrorMsg]);

    const cellClickedListener = (e) => {
    const rows = e.api?.getSelectedRows?.() || [];
     if (selectedRows.length > 0) {
      onClickSearch();
    }
    // if (rows.length > 0) {
    //   onClickSearch();
    // }
  };
  const [gridApi, setGridApi] = React.useState(null);
  const onGridReady = (params) => {
  setGridApi(params.api);
  };
  React.useEffect(() => {
    if (!gridApi || manufacturerList === 0) return;
    const selectedRows = gridApi.getSelectedRows();
    if (selectedRows.length > 0) return;
    const firstNode = gridApi.getDisplayedRowAtIndex(0);
    if (firstNode) {
      firstNode.setSelected(true);
      onSelectionChanged({ api: gridApi });
    }
  }, [gridApi, manufacturerList]);

  return (
    <div className="tabs-container">
      <Spinner load={isLoading} />
      {!fullScreenView && (
        <>
          <CustomSeparator
            parent1="State Reports"
            parent2="Outstanding Balance by Labeler and Quarter"
          />
          <DisplayErrorMessages
            errorMessages={[
              ...new Set(
                getErrorMsg?.length > 0
                  ? _.map(getErrorMsg, (l) => l.message)
                  : []
              ),
            ]}
          />
        </>
      )}

      {!fullScreenView && (
        <div className="tab-body custom-search-dates">
          <div className="row ml-2 mb-3 ">
            <div className="col-4 ">
              <FormControlLabel
                control={
                  <Checkbox
                    color="primary"
                    checked={allRebateProgram}
                    name="allRebateProgram"
                    onBlur={() => {}}
                    onChange={() => {
                      setAllRebateProgram(!allRebateProgram);
                      const tempRadioList = radioList?.map((item) => {
                        return { ...item, disabled: !allRebateProgram };
                      });
                      setRadioList(tempRadioList);
                      let localErr = getErrorMsg || [];
                      localErr = localErr.filter(
                        (item) => item.field !== 'rebateProgramCd'
                      );
                      const unique = [...new Set(localErr)];
                      dispatch(
                        dispatchErrorMsgOutStandingBalByLabererAndQtr(unique)
                      );
                    }}
                  />
                }
                label="All Rebate Programs"
              />
            </div>
          </div>
          <div className="row">
            <div className="col-4 frr-two-col-radio">
              <RadioGroupComponent
                disabled
                data-testid="OLQ_PlanType"
                id="filter-plan-by-radio-btn-action"
                labelName={radioGroupLabelNamePlan}
                required={false}
                optionList={radioList || []}
                defaultValue={state && state.planTypeCd}
                filterAction={(e) => {
                  handleOnChangeEvent(e, 'planTypeCd');
                }}
                className="log-batch-filter-radio frr-checkInvoiceRadio"
              />
            </div>
            <div className="col-4">
              <fieldset className="custom-fieldset">
                <legend className="same-font-family">Rebate Program</legend>
                <div className="form-wrapper p-0">
                  <div className="mui-custom-form with-select field-xl no-lbl">
                    <TextField
                      name="rebateProgram"
                      label="Rebate Program"
                      id="rebateProgramreq"
                      disabled={allRebateProgram}
                      data-testid="OLQ_RebateProgram"
                      fullWidth
                      select
                      required
                      inputProps={{ maxLength: 11, id: 'rebateProgramreq' }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      className={
                        getErrorMsg?.length > 0
                          ? _.map(getErrorMsg, (l) =>
                              l.field === 'rebateProgramCd'
                                ? 'mandate-fields frr-display-hidden-label'
                                : 'frr-display-hidden-label'
                            )
                          : 'frr-display-hidden-label'
                      }
                      onBlur={(e) =>
                        handleOnblurEvent('rebateProgramCd', e.target.value)
                      }
                      onChange={(e) =>
                        handleOnChangeEvent(e.target.value, 'rebateProgramCd')
                      }
                      value={
                        state && state.rebateProgramCd
                          ? state.rebateProgramCd
                          : ''
                      }
                      error={
                        getErrorMsg?.length > 0
                          ? _.map(getErrorMsg, (l) =>
                              l.field === 'rebateProgramCd' ? l.message : null
                            )
                          : null
                      }
                      helperText={
                        getErrorMsg?.length > 0
                          ? _.map(getErrorMsg, (l) =>
                              l.field === 'rebateProgramCd' ? l.message : null
                            )
                          : null
                      }
                    >
                      <MenuItem
                        key=""
                        value="-1"
                        className="frr-dropdown-blank-item"
                      />
                      {rebateProgramList &&
                      rebateProgramList.length &&
                      rebateProgramList.length > 0
                        ? rebateProgramList.map((item) => {
                            return (
                              <MenuItem key={item.id} value={item.id}>
                                {item.name}
                              </MenuItem>
                            );
                          })
                        : null}
                    </TextField>
                  </div>
                </div>
              </fieldset>
            </div>
            <div className="col-3 mui-custom-form input-md field-xl">
              <FormControlLabel
                style={{ marginTop: '40px' }}
                control={
                  <Checkbox
                    checked={isAllManufacturersSelected}
                    color="primary"
                    name="allManufacturers"
                    onChange={(e) => {
                      setIsAllManufacturersSelected(!isAllManufacturersSelected);
                      if (!isAllManufacturersSelected) {
                        setManufacturerSelected('ALL');
                      } else {
                        setManufacturerSelected([]);
                      }
                    }}
                  />
                }
                label="All Manufacturers"
              />
            </div>
          </div>

          <div className="row">
            <div className="col-12 btn-wrapper mb-2">
              <div className="float-right mt-2 hide-on-print">
                <Button
                  className="btn btn-success btn-search"
                  data-testid="view_detail_ia"
                  type="button"
                  onClick={onClickSearch}
                >
                  {' '}
                  <SVGComponent iconName="Icon-search" /> Search
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="row" id="abc11">
        {!isAllManufacturersSelected && (
          <div className="col-12 unallocated">
            <TableGrid
              onSelectionChanged={onSelectionChanged}
              rowData={manufacturerList || []}
              helpMessage={true}
              gridCall={onGridReady}
              fullScreenView={fullScreenView}
              handleFullScreenViewClick={handleFullScreenView}
              gridHeight={fullScreenView ? '100vh' : viewPortHeight_355}
              columnDefs={AllManufacturer}
              cellClickedListener={cellClickedListener}
              selectRowIndex={selectRowIndexValue}
              rowSelection="single"
              data-testid="onEditingStopped"
              fileName="Manufacturer List"
              enterMovesDown
              suppressCellFocus
              singleClickEdit
              exportFile
              hideColumnsInPdf={true}
              frameworkComponents={{
                TextBoxRender: (cellInfo) => {
                  const name = cellInfo?.value;

                  if (name && name.length > 30) {
                    return (
                      <OverlayTrigger
                        placement="bottom"
                        overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
                      >
                        <div>{name && `${name.substring(0, 30)}...`}</div>
                      </OverlayTrigger>
                    );
                  }
                  return <div>{name}</div>;
                },
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ReqOutstandingByLabererAndQuarter;
